export default {
    help: 'Help',
    howTo: 'Enter the search parameters and click «Find carriers»'
};
